import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../app/AuthContext";
import { errorMessage } from "../api/client";
import { AuthFrame } from "../components/AuthFrame";
import { RecoveryCode } from "./LoginPage";

export function RegisterPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [recoveryCode, setRecoveryCode] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    if (password !== confirmation) {
      setError("两次输入的密码不一致。");
      return;
    }
    setBusy(true);
    setError(null);
    try {
      setRecoveryCode(await auth.signUp({ email, displayName, password }));
    } catch (cause) {
      setError(errorMessage(cause));
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthFrame
      title={recoveryCode ? "文明档案已建立" : "建立新的文明"}
      eyebrow={recoveryCode ? "ARCHIVE READY" : "CIVILIZATION GENESIS"}
      alternate={{ to: "/login", prompt: "已有文明档案？", label: "返回登录" }}
    >
      {recoveryCode ? (
        <div className="form-stack">
          <RecoveryCode code={recoveryCode} />
          <button className="button primary full" onClick={() => navigate("/game", { replace: true })}>
            保存完毕，创建第一个存档
          </button>
        </div>
      ) : (
        <form className="form-stack" onSubmit={submit}>
          <div>
            <h2>注册</h2>
            <p className="muted">先建立安全账号，登录后可创建至多五个独立文明存档。</p>
          </div>
          {error && <div className="alert danger" role="alert">{error}</div>}
          <label>
            <span className="field-label">邮箱</span>
            <input name="email" type="email" autoComplete="email" required value={email} onChange={(event) => setEmail(event.target.value)} />
          </label>
          <label>
            <span className="field-label">显示名</span>
            <input name="displayName" autoComplete="nickname" minLength={2} maxLength={40} required value={displayName} onChange={(event) => setDisplayName(event.target.value)} />
          </label>
          <label>
            <span className="field-label">密码</span>
            <input name="password" type="password" autoComplete="new-password" minLength={10} maxLength={128} required value={password} onChange={(event) => setPassword(event.target.value)} />
            <span className="field-hint">10–128 个字符，可直接粘贴密码管理器生成的密码</span>
          </label>
          <label>
            <span className="field-label">确认密码</span>
            <input name="confirmation" type="password" autoComplete="new-password" minLength={10} maxLength={128} required value={confirmation} onChange={(event) => setConfirmation(event.target.value)} />
          </label>
          <button className="button primary full" type="submit" disabled={busy}>
            {busy ? "正在建立账号…" : "创建账号"}
          </button>
        </form>
      )}
    </AuthFrame>
  );
}
